import { Flame } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { SoundToggle } from "@/components/SoundToggle";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-gold/10 bg-surface/40 py-14"
  >
    <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-8 px-6 sm:px-12 md:flex-row">
      <div className="flex items-center gap-3">
        <Flame className="h-4 w-4 text-gold" />
        <span className="font-cinzel text-xs tracking-[0.35em] text-cream">
          IMMERSIVE AT HOME
        </span>
      </div>
      <div className="flex items-center gap-8">
        <button
          data-testid="footer-link-experience"
          onClick={() => scrollToId("#experience")}
          className="text-[11px] uppercase tracking-[0.2em] text-ash transition-colors hover:text-gold"
        >
          The Experience
        </button>
        <button
          data-testid="footer-link-episodes"
          onClick={() => scrollToId("#seasons")}
          className="text-[11px] uppercase tracking-[0.2em] text-ash transition-colors hover:text-gold"
        >
          Episodes
        </button>
        <a
          data-testid="footer-contact-link"
          href="mailto:spirits@immersiveathome.com"
          className="text-[11px] uppercase tracking-[0.2em] text-ash transition-colors hover:text-gold"
        >
          spirits@immersiveathome.com
        </a>
      </div>
      <p className="text-[11px] tracking-[0.15em] text-ash">
        © 2026 IMMERSIVE AT HOME
      </p>
    </div>
    <SoundToggle />
  </footer>
);
